import React, { useEffect, useState } from "react";

// Listens for "axios-loading" CustomEvents (dispatched from helpers/api_helper.js)
// and renders a thin animated bar at the top of the viewport while any
// axios request is in flight.
const GlobalLoadingBar = () => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      const count = (e.detail && e.detail.count) || 0;
      setActive(count > 0);
    };
    window.addEventListener("axios-loading", handler);
    return () => window.removeEventListener("axios-loading", handler);
  }, []);

  if (!active) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "3px",
        zIndex: 9999,
        background:
          "linear-gradient(90deg, transparent 0%, var(--vz-primary, #405189) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "globalLoadingShimmer 1.1s infinite linear",
        pointerEvents: "none",
      }}
    >
      <style>{`
        @keyframes globalLoadingShimmer {
          0%   { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
      `}</style>
    </div>
  );
};

export default GlobalLoadingBar;
